export default "__VITE_ASSET__DSFrWzjM__"